'use es6';

import { fetchAll } from 'AdsUI/data/LifecycleStagesData';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
export function fetchAllLifecycleStages() {
  return dispatch => wrapReduxAction(fetchAll, 'LIFECYCLE_STAGES_FETCH', {
    dispatch
  });
}